export var SPACING_FACTOR = 4;
export var defaultThemeDeclaration = {
  spacing: SPACING_FACTOR
};